
    // IMPORTS
    import { computed, defineComponent, PropType } from 'vue'
    import { buildMaterialLocalization } from '@/util';

    import MaterialPicture from '@/components/common/material-picture.vue'
    import DocIcon from '@/components/common/doc-icon.vue'

    import { IMaterialDTO, MaterialListItem } from '@/types/material';

    export default defineComponent({
        name: 'materialLink',

        components: {
            MaterialPicture,
            DocIcon
        },

        props: {
            materialData: { type: Object as PropType<IMaterialDTO | MaterialListItem>, required: true },
            lazyLoad: { type: Boolean as PropType<boolean>, required: false, default: () => false },
            size: { type: Number as PropType<number>, required: false, default: () => 100 },
            fill: { type: Boolean as PropType<boolean>, required: false, default: () => false }
        },

        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            click: () => true
        },

        setup(props, { emit }) {
            /********************************************************************************************************************
             PRIVATE
             ********************************************************************************************************************/
            const { materialTextFor } = buildMaterialLocalization()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = {}

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const materialNo = computed(() => props.materialData.materialNo)
            const materialText = computed(() => isMaterialListItem(props.materialData)
                ? props.materialData.description
                : materialTextFor(props.materialData)
            )
            const infoText = computed(() => `${materialNo.value} ${materialText.value}`
            )
            const containerStyle = computed(() => props.fill
                ? 'height: 100%; width: 100%; box-sizing: border-box; padding: 15px;'
                : `height: ${props.size}px; width: ${props.size}px; padding: 15px;`
            )

            const materialLinkClass = computed(() => props.fill
                ? 'material-link-grid'
                : 'material-link-flow'
            )

            const computedData = {
                materialNo,
                materialText,
                infoText,
                containerStyle,
                materialLinkClass
            }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            function onClick() {
                emit('click')
            }
            
            const publicMethods = { onClick }

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/
            function isMaterialListItem(obj: any): obj is MaterialListItem {
                return obj.description !== undefined
            }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
